var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zcy-list" }, [
    _c(
      "div",
      { staticClass: "hd" },
      [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
        _vm.isSearching
          ? _c(
              "a-button",
              { staticClass: "reset-btn", on: { click: _vm.reset } },
              [_vm._v("重置")]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "bd" },
      [
        _c("a-spin", { attrs: { spinning: _vm.isLoading } }, [
          _vm.hasData
            ? _c("div", { staticClass: "list-wrap" }, [
                _c(
                  "ul",
                  { staticClass: "list-container" },
                  _vm._l(_vm.list, function(item, index) {
                    return _c("li", { key: index, staticClass: "list-item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "item-link",
                          attrs: { href: "/detail.html?id=" + item.id }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "left",
                              attrs: { title: item.districtType }
                            },
                            [
                              _c("span", { staticClass: "left-title" }, [
                                _vm._v(_vm._s(item.districtType))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "mid",
                            domProps: { innerHTML: _vm._s(item.title) }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "right" },
                            [
                              _c("app-icon", {
                                attrs: { type: "iconshijian" }
                              }),
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.date) +
                                  "\n              "
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pagination-wrap" },
                  [
                    _c("a-pagination", {
                      attrs: {
                        showQuickJumper: "",
                        current: _vm.current,
                        pageSize: 15,
                        total: _vm.total
                      },
                      on: { change: _vm.onChange }
                    })
                  ],
                  1
                )
              ])
            : _c("div", { staticClass: "list-empty" })
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b5cafbf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b5cafbf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/list.vue
// module id = ODI+
// module chunks = 1